import { DrillThroughDataTable } from "@/components/DrillThroughDataTable";
import type { DrillThroughTableConfig } from "@/types/drillThroughTable";

type DrillThroughTablesPanelProps = {
  tables: DrillThroughTableConfig[];
};

export function DrillThroughTablesPanel({ tables }: DrillThroughTablesPanelProps) {
  return (
    <section className="space-y-3">
      {tables.map((table) => (
        <DrillThroughDataTable
          key={table.title}
          title={table.title}
          rows={table.rows}
          columns={table.columns}
          loading={table.loading}
          loadingMessage={table.loadingMessage}
          refetching={table.refetching}
          error={table.error}
          groupByClient={table.groupByClient}
          totalRows={table.totalRows}
          countNoun={table.countNoun}
          hasMore={table.hasMore}
          loadingMore={table.loadingMore}
          onLoadMore={table.onLoadMore}
          sort={table.sort}
          onSort={table.onSort}
        />
      ))}
    </section>
  );
}
